export default "__VITE_ASSET__DNgcJMqE__"